import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { dateTimeFacade, dateTimeHelper, getContrastYIQ, LayoutService } from '@cf/core';
import { LoaderContainerComponent } from '@cf/shared/ui/loading';
import {
  AccountService,
  AppEventApiService,
  ITimeslots,
  SchemaAppEventDetail,
  SchemaMeetingInfo,
} from '@cf/temp/services';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { BookingConfirmationComponent, BookingFooterComponent } from '../../components';

const TOKEN_PARAM = 'stripeReturnToken';

@Component({
  selector: 'cf-stripe-payment-callback',
  templateUrl: './stripe-payment-callback.component.html',
  styleUrl: './stripe-payment-callback.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatProgressSpinner,
    NgIf,
    LoaderContainerComponent,
    BookingConfirmationComponent,
    NgxTolgeeModule,
    BookingFooterComponent,
  ],
})
export class StripePaymentCallbackComponent implements OnInit {
  booking!: SchemaAppEventDetail & SchemaMeetingInfo;
  selectedSlot!: ITimeslots;
  selectedTime!: string;
  selectedDuration!: string;

  loading = signal(true);

  readonly destroyRef = inject(DestroyRef);

  constructor(
    public accountService: AccountService,
    private readonly layoutService: LayoutService,
    private readonly appEventApiService: AppEventApiService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    this.layoutService.hideHeader.next(true);
  }

  ngOnInit() {
    const token = this.route.snapshot.queryParams[TOKEN_PARAM];
    if (!token) {
      void this.router.navigate(['error/404']);
      return;
    }

    this.getData(token);
  }

  getData(token: string) {
    this.loading.set(true);
    this.appEventApiService
      .event(token)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.booking = res as SchemaAppEventDetail & SchemaMeetingInfo;
          (this.booking.meeting_template as any).location = res.event_location;

          this.selectedTime = dateTimeHelper.getTime(this.booking.start, 12);
          this.selectedDuration = dateTimeFacade.timeToDuration(this.booking.duration).toString();

          if (this.booking.meeting_template?.picture) {
            this.booking.meeting_template = {
              ...this.booking.meeting_template,
              // with_picture: true,
            };
          }

          this.selectedSlot = {
            date: this.booking.start,
            free_slots: [{ start: this.booking.start, end: this.booking.end }],
          };

          this.loading.set(false);
        },
      });
  }

  protected readonly getContrastYIQ = getContrastYIQ;
}
